import { SelectItemModel } from '@app/src/common/Select/SelectModel';
import { TypeVehicleModel } from '@app/src/views/StepOne/form/models/typeVehicle';
import { TypeVehicleDTO } from '@app/src/views/StepOne/form/dtos';

export const hydrateData = (data: TypeVehicleDTO[]) =>
  data.map((item: TypeVehicleModel) => ({
      value: String(item.id),
      text: item.name,
      data: {...item}
  })) as SelectItemModel[];
